import { HeadCell } from "@/components/app/EnhancedTableHeader/type";

const headCells: HeadCell<any>[] = [
    {
        id: "id",
        numeric: true,
        disablePadding: true,
        label: "ID",
    },
    {
        id: "title",
        label: "Title",
        numeric: false,
        disablePadding: true,
    },
    {
        id: "amountType",
        label: "Type",
        numeric: false,
        disablePadding: true,
    },
    {
        id: "amountValue",
        label: "Value",
        numeric: true,
        disablePadding: true,
    },
    {
        id: "appliedTo",
        label: "Applied To",
        numeric: false,
        disablePadding: true,
    },
    {
        id: "status",
        label: "Status",
        numeric: false,
        disablePadding: true,
    },
    {
        id: "expireDate",
        label: "Expire Date",
        numeric: false,
        disablePadding: true,
    },
    {
        id: "usageLimit",
        label: "Usage Limit",
        numeric: true,
        disablePadding: true,
    },
    {
        id: "usageCount",
        label: "Used Count",
        numeric: true,
        disablePadding: true,
    },
];

export default headCells;
